module.exports = __webpack_public_path__ + "img/avatar5.0554f226.png";